export default {
  login: {
    url: '/api/login',
    method: 'post',
  },
  sendCheckCode: {
    url: '/api/sendCheckCode',
    method: 'post',
  },
  imageCheck: {
    url: '/api/imageCheck',
    method: 'post',
  },
  checkCodeAndPassword: {
    url: '/api/checkCodeAndPassword',
    method: 'post',
  },
  showRegistersByCode: {
    url: '/api/showRegistersByCode',
  },
  register: {
    url: '/api/register',
    method: 'post',
  },
  sendMail: {
    url: '/api/sendMail',
    method: 'post',
  },
  resetPassword: {
    url: '/api/resetPassword',
    method: 'post',
  },
  refreshToken: {
    url: '/refreshToken',
  },
  saveUserDesire: {
    url: '/api/saveUserDesire',
    method: 'post',
  },
  suppRegisterFileUpload: {
    url: '/api/suppRegisterFileUpload',
    method: 'post',
  },
  downLoadModel: {
    url: '/api/downLoadModel',
    method: 'post',
    responseType: 'blob'
  },
  downLoadFile: {
    url: '/api/downLoadFile',
    method: 'get',
    responseType: 'blob'
  },
  downLoadFileBase64: {
    url: '/api/downLoadFile',
    method: 'get',
  },
};
